//import utility from '@/mixins/utility'

//import _ from 'lodash'
import moment from 'moment'

class User {

  #data = {}

  #paymentMethods = []

  #subscriptions = []

  constructor(collection={})
  {
    this.#data = collection

    //this.#paymentMethods = utility.methods.mapModels(collection.payment_methods, 'paymentMethod')

    //this.#subscriptions = utility.methods.mapModels(collection.subscriptions, 'subscription')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active == true
  }

  get email()
  {
    return this.#data.email
  }

  get emailVerifiedAt()
  {
    let value = this.#data.email_verified_at

    return value ? moment(value) : null
  }

  get firstname()
  {
    return this.#data.firstname
  }

  get id()
  {
    return this.#data.id
  }

  get lastname()
  {
    return this.#data.lastname
  }

  get token()
  {
    return this.#data.token
  }

  /**
   * Computed properties.
   */
  
  get fullname()
  {
    const fullname = this.hasFullname ? 
                      [ this.name, this.lastname ].join(' ') : ''

    return fullname
  }

  get hasFullname()
  {
    return this.firstname && this.lastname
  }

  get name()
  {
    return this.fullname
  }

  /**
   * Methods.
   */
  
  

}

export default User